import template from './system_notifications_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class SystemNotificationsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class SystemNotificationsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SystemNotificationsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'SystemNotificationsHelp',
	dialog_class: SystemNotificationsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/system_notifications_help',
	provider: 'ps'
};
